import { render, staticRenderFns } from "./app-title-page.vue?vue&type=template&id=7f680666&scoped=true&"
import script from "./app-title-page.vue?vue&type=script&lang=js&"
export * from "./app-title-page.vue?vue&type=script&lang=js&"
import style0 from "./app-title-page.vue?vue&type=style&index=0&id=7f680666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f680666",
  null
  
)

export default component.exports